<template>
   <div :class="themeColor?'search-overlay-color':'search-overlay'" v-if="isShow">
      <div class="search-header">
         <cc-svg-icon
           icon-class="left-arrow"
           class-name="left-arrow"
           @click="$emit('cacel')"
           size=".2rem"
         ></cc-svg-icon>
         <div class="search-input">
            <cc-svg-icon iconClass="search" className="search-icon"/>
<!--            <input type="text"  >-->
            <form action="javascript:void(0)">
               <input
                 @keypress="searchBtn"
                 v-focus
                 v-model="val"
                 type="search"
                 :placeholder="placeholder" />
            </form>
            <cc-svg-icon
              v-show="val"
              @click="val = ''"
              iconClass="cancel"
              :className="cancelIconColor?'cancel-icon-change':'cancel-icon'"/>
         </div>
         <span @click="search" class="search_text">搜索</span>
      </div>
      <div class="content" @click.self="$emit('cacel')">
         <slot></slot>
      </div>
   </div>
</template>

<script>
export default {
  name: 'cc-search-overlay',
  props: {
    placeholder: {
      type: String,
      default: '搜索你想要的商品'
    },
    value: {
      type: String,
      default: ''
    },
    show: {
      type: Boolean,
      default: true
    },
    // 头部是否随主题色
    themeColor: {
      type: Boolean,
      default: false
    },
    cancelIconColor: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      isShow: this.show,
      val: this.value
    }
  },
  methods: {
    search () {
      this.$emit('search')
    },
    searchBtn (event) {
      if (event.keyCode === 13) { // 如果按的是enter键 13是enter
        event.preventDefault() // 禁止默认事件（默认是换行）
        if (!this.val.trim()) {
          return false
        } else {
          this.$emit('search')
        }
      }
    }
  },
  watch: {
    val (val) {
      this.$emit('input', val)
    },
    value (val) {
      this.val = val
    },
    show (val) {
      this.isShow = val
    }
  }
}
</script>

<style scoped lang="scss">
   .search-overlay {
      position: fixed;
      z-index: 21;
      width: 100vw;
      height: 100vh;
      background: rgba(0, 0, 0, 0.5);
      display: flex;
      flex-direction: column;
      .search-header {
         height: 45px;
         width: 100%;
         background: #ffffff;
         align-items: center;
         display: flex;
         justify-content: space-between;
         box-sizing: border-box;
         padding: 0 11px;
         .search-input{
            width: 280px;
            height: 29px;
            border: none;
            border-radius: 15px;
            overflow: hidden;
            box-sizing: border-box;
            display: flex;
            align-items: center;
            background: rgba(238,238,238,1);
            position: relative;
            form{
               height: 100%;
               flex: 1;
               input{
                  border: none;
                  height: 100%;
                  width: 100%;
                  background: rgba(238,238,238,1);
                  &::-webkit-search-cancel-button { display: none; }
               }
            }
            .search-icon{
               color: #999999;
               width: 25px;
               margin: 0 5px;
            }
            .cancel-icon{
               width: 25px;
               margin: 0 5px;
               color: rgb(219, 219, 219);
            }
         }
      }
      .content{
         flex: 1;
         overflow-y:auto;
      }
   }
   .search-overlay-color {
      position: fixed;
      z-index: 21;
      width: 100vw;
      height: 100vh;
      // background: rgba(0, 0, 0, 0.5);
      display: flex;
      flex-direction: column;
      .search-header {
         height: 45px;
         width: 100%;
         background: linear-gradient(to right,var(--APP_theme_color) , var(--APP_theme_color_colorOpacity5));
         align-items: center;
         display: flex;
         justify-content: space-between;
         box-sizing: border-box;
         padding: 0 11px;
         .search-input{
            width: 280px;
            height: 29px;
            border: none;
            border-radius: 15px;
            overflow: hidden;
            box-sizing: border-box;
            display: flex;
            align-items: center;
           background: rgba(255,255,255,.5);
            position: relative;
            form{
               height: 100%;
               flex: 1;
               input{
                  border: none;
                  height: 100%;
                  width: 100%;
                  // background: #000;
                  background: rgba(255,255,255,0);
                    color: #fff;
                  &::-webkit-search-cancel-button { display: none; }
                  &::-webkit-input-placeholder { /* WebKit browsers 适配谷歌 */
                      color: #fff;
                  }
                  &:-moz-placeholder { /* Mozilla Firefox 4 to 18 适配火狐 */
                      color: #fff;
                  }
                  &::-moz-placeholder { /* Mozilla Firefox 19+ 适配火狐 */
                      color: #fff;
                  }
                  &:-ms-input-placeholder { /* Internet Explorer 10+  适配ie*/
                      color: #fff;
                  }
               }
            }
            .search-icon{
               color: #fff;
               width: 25px;
               margin: 0 5px;
            }
            .cancel-icon{
               width: 25px;
               margin: 0 5px;
               color:rgb(211, 209, 209);
            }
            .cancel-icon-change{
                width: 25px;
               margin: 0 5px;
               color: #fff;
            }
         }
      }
      .content{
        background: rgba(0, 0, 0, 0.5);
         flex: 1;
         overflow-y:auto;
      }
      .search_text{
        color: #fff;
      }
   }
</style>
